import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import CompleteAccountOpeningButton
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ActionsPicker/CompleteAccountOpeningButton/CompleteAccountOpeningButton';
import CompleteFundingButton
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ActionsPicker/CompleteFundingButton/CompleteFundingButton';
import CompleteAnnualReviewButton
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ActionsPicker/CompleteAnnualReviewButton/CompleteAnnualReviewButton';
import DefaultActions
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ActionsPicker/Default/DefaultActions';
import CompleteAccountRetitlingButton
  from 'Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ActionsPicker/CompleteAccountRetitlingButton/CompleteAccountRetitlingButton';

const ActionsPicker = ({ resource, completed, ...rest }) => {
  return pick(resource, {
    [fr.relationships.transferWizard.name]: <CompleteFundingButton resource={resource} completed={completed} />,
    [fr.relationships.fundingInstructionsPage.name]: <CompleteFundingButton resource={resource} completed={completed} />,
    [fr.relationships.accountRetitlingWizard.name]: <CompleteAccountRetitlingButton resource={resource} completed={completed} />,
    [fr.relationships.accountOpeningWizard.name]: <CompleteAccountOpeningButton resource={resource} completed={completed} />,
    [fr.relationships.annualInvestmentReview.name]: <CompleteAnnualReviewButton resource={resource} completed={completed} />,
  }, <DefaultActions resource={resource} completed={completed} {...rest} />);
};

export default ActionsPicker;
